import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_RICH_PLACEMENT_MULTIANCHOR: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateRichPlacementMultianchor(
    $input: UpdateWorkspaceRichPlacementMultianchorConfigurationInput!
  ) {
    updateWorkspaceRichPlacementMultianchorConfiguration(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
